













import Vue from 'vue';
import { State } from 'vuex-class';
import { Component } from 'vue-property-decorator';
import { TPage } from '@/types/utils.d.ts'
import { getOrgByPage, getBranchPage, getOrgInfo } from '@/api/school';
const namespace = 'user';
@Component({
    components: {
        Search: () => import('./components/search.vue'),
        List: () => import('./components/list.vue')
    }
})
export default class ManageTab extends Vue {
    @State('orgId', { namespace }) orgId!: string;
    search = {
      parentId: '',
      pageSize: 20,
      currentPage: 1
    }
    // orgId = ''
    branchPage: TPage = {
      currentPage: 1,
      pageSize: 20
    }
    activated () {
      this.init()
    }
    async init() {
      // await this.getOrgInfo()
      await this.getData()
    }
    // async getOrgInfo() {
    //   try {
    //     let res = await getOrgInfo()
    //     this.orgId = res.orgInfo.id
    //   } catch (e) {
    //     this.$message.error(e.message)
    //   }
    // }
    async getData() {
      try {
        let search = {...this.search, ...{parentId: this.orgId}}
        // this.branchPage = await getBranchPage(
        //   search
        // );
        this.branchPage = await getOrgByPage(
          search
        );
      } catch (e) {
        this.$message.error(e.message);
        this.branchPage = {
          currentPage: 1,
          pageSize: 20
        }
      }
    }
    handleOptions(opts: any) {
        this.search = {...this.search, ...opts}
    }
}
